import React from 'react';
import { AlertBox, Box } from '@origin-digital/style-guide';
import { IError } from '../interfaces';

interface LoginErrorBoxProps {
  error: IError;
}

const LoginErrorBox: React.FC<LoginErrorBoxProps> = ({ error }) => (
  <>
    {error && (
      <Box marginBottom={6}>
        <AlertBox
          data-id={'LoginPage__errorBox'}
          type="error"
          heading={error.heading}
          message={error.body}
          markdown={true}
        />
      </Box>
    )}
  </>
);

export { LoginErrorBox };
